import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, RouterModule } from '@angular/router';
import { NavigationStore } from '@argo/navigation';
import { AuthenticationStore } from '@argo/authentication';
import { 
  ScaMenuModule,
  ScaButtonComponent,
  ScaAvatarModule,
  ScaListModule,
  ScaIconComponent,
  ScaTabsModule,
  ScaGridModule,
  ScaBreadcrumbModule,
  ScaModuleTitleComponent,
  ScaFooterBottomComponent,
  ScaChipComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,
    ScaMenuModule,
    ScaButtonComponent,
    ScaAvatarModule,
    ScaListModule,
    ScaIconComponent,
    ScaTabsModule,
    ScaGridModule,
    ScaBreadcrumbModule,
    ScaModuleTitleComponent,
    ScaFooterBottomComponent,
    ScaChipComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Argo v8 Playground';
  private navStore = inject(NavigationStore);
  readonly authStore = inject(AuthenticationStore);
  
  // Computed properties para el header
  readonly user = computed(() => this.authStore.user());
  readonly logged = computed(() => this.authStore.logged());
  readonly isAuthenticating = computed(() => this.authStore.isAuthenticating());
  readonly secondsToLogout = computed(() => this.authStore.secondsToLogout());
  readonly almostExpired = computed(() => this.authStore.almostExpired());

  constructor(private router: Router) {
    this.navStore.initNavigation();
  }

  onTabChange(value: string): void {
    this.router.navigate([value]);
  }

  login() {
    this.authStore.login({ interactive: true });
  }

  logout() {
    this.authStore.logout();
  }

  getCurrentRoute(): string {
    const url = this.router.url;
    // Return full path for nested routes (e.g., 'test/auth')
    return url.startsWith('/') ? url.substring(1) : url || 'test/auth';
  }

  isInTestSection(): boolean {
    return this.router.url.startsWith('/test');
  }

  isHomePage(): boolean {
    return this.router.url === '/' || this.router.url === '/home';
  }
}
